<template>
  <gg-card>
    <gg-card-header>
      Add an IP or Range
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <v-radio-group v-model="model.radio" row>
            <v-radio v-for="(item, key) in radioItems" :label="item.text" :value="item.value"  :key="key" />
          </v-radio-group>
        </v-col>
        <v-col cols="12" md="4" lg="3">
          <gg-text-field v-model="model.firstIp"
                         :label="beginLabel"
                         v-validate="'ipValidator|required'"
                         name="firstIp"
                         data-vv-as="IP Address or Domain"
                         :error-messages="errors.collect('firstIp')"
                         :hint="beginHint"
          />
        </v-col>
        <v-col cols="12" md="4" lg="3" v-if="model.radio === 'range'">
          <gg-text-field v-model="model.lastIp"
                         :label="endLabel"
                         v-validate="'ipValidator|required'"
                         name="lastIp"
                         data-vv-as="IP Address"
                         :error-messages="errors.collect('lastIp')"
                         :hint="endHint"
          />
        </v-col>
      </v-row>

      <gg-btn :loading="pending" @click="addNewIp">Add</gg-btn>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions } from 'vuex'
import { ipValidator } from 'Helpers/validators'
import { Validator } from 'vee-validate'

export default {
  name: 'AddNewIp',
  data: () => ({
    radioItems: [
      {
        text: 'Single IP or Domain',
        value: 'single'
      },
      {
        text: 'Range IP',
        value: 'range'
      },
    ],
    model: {
      radio: 'single',
      firstIp: '',
      lastIp: ''
    },
    pending: false
  }),
  created () {
    Validator.extend('ipValidator', ipValidator)
  },
  computed: {
    ip () {
      if (this.model.radio === 'single') {
        return this.model.firstIp
      } else {
        return `${this.model.firstIp}-${this.model.lastIp}`
      }
    },
    beginLabel () {
      return this.model.radio === 'single' ? 'IP Address or Domain' : 'Beginning IP'
    },
    beginHint () {
      return this.model.radio === 'single' ? '' : ' (For example: 192.168.0.1)'
    },
    endLabel () {
      return 'Ending IP'
    },
    endHint () {
      return '(For example: 192.168.0.10)'
    }
  },
  methods: {
    ...mapActions({
      addIpToBlackList: 'hosting_security/addIpToBlackList',
      getIpList: 'hosting_security/getIpList',
      reportError: 'reportError'
    }),
    async getData () {
      try {
        await this.getIpList(this.$route.query.user)
      } catch (e) {
        this.reportError(e)
      } finally {
      }
    },
    async addNewIp () {
      try {
        const isValid = await this.$validator.validateAll()

        if (!isValid) {
          return
        }

        this.pending = true

        await this.addIpToBlackList({ ip: this.ip, _username: this.$route.query.user })
        await this.getIpList(this.$route.query.user)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    }
  }
}
</script>

<style scoped>

</style>
